import { noPayload, payload } from '@angular-architects/ngrx-toolkit';
import { IMDMCustomer } from '../../modules/user-management/types/mdm-customer';
import {
    IGenerateQROnboardingPayload,
    IQROnboardingDetails,
} from '../../modules/user-management/types/qr-onboarding';
import { IClientDetail } from '@app/modules/client-management/types/client-detail';
export const companyActions = {
    public: {
        setClientDetailInfo: payload<{
            value: IClientDetail;
        }>(),
        setClientInfo: payload<{
            value: IMDMCustomer;
        }>(),
        setId: payload<{
            value: string;
        }>(),
        setQrDetails: payload<{
            value: IQROnboardingDetails;
        }>(),
        setGenerateQRDetails: payload<{
            value: IGenerateQROnboardingPayload;
        }>(),
        getClientDetailInfo: payload<{
            id: string;
        }>(),
        getVendorDetailInfo: payload<{
            id: string;
        }>(),
        getClientCompanyLogo: payload<{
            id: string;
        }>(),
        setIsVendorUser: payload<{
            value: boolean;
        }>(),
        setClientLogo: payload<{
            value: string;
        }>(),
        resetQrDetails: noPayload,
        resetGenerateQRDetails: noPayload,
        resetClientDetailInfo: noPayload,
        resetClientInfo: noPayload,
        reset: noPayload,
    },
    private: {
        resetAll: payload<{
            clientInfo: IMDMCustomer;
            qrDetails: IQROnboardingDetails;
            generateQRDetails: IGenerateQROnboardingPayload;
            id: string;
            isBusy: boolean;
        }>(),
        setIsBusy: payload<{
            value: boolean;
        }>(),
    },
};

export type CompanyActions = typeof companyActions;
